import styled from 'styled-components';

export const Footer = styled.footer`
  background-color: #f5f5f5;
  padding: 16px;
  text-align: center;
`;